import { render, staticRenderFns } from "./simDistribut.vue?vue&type=template&id=3b58ab3f&scoped=true&"
import script from "./simDistribut.vue?vue&type=script&lang=js&"
export * from "./simDistribut.vue?vue&type=script&lang=js&"
import style0 from "./simDistribut.vue?vue&type=style&index=0&id=3b58ab3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58ab3f",
  null
  
)

export default component.exports